<template>
  <div class="application">
    <div style="text-align: center">
      <img alt="Client Guard logo" src="./assets/logo.svg" style="width: 250px" />
    </div>
    <Shell />
  </div>
</template>

<script>
import Shell from './components/Shell.vue';

export default {
  components: {
    Shell
  }
};
</script>

<style lang="scss">
:root {
  --theme-primary: rgb(0, 120, 212);

  --theme-secondary: #fff;

  --theme-highlight: rgba(0, 0, 0, 0.05);

  --theme-success: #2e815b;
  --theme-error: #b00020;
  --theme-background: #fff;
  --theme-warning: #b00020;

  --theme-surface: #fff;
  // --theme-surface: #424242;

  // --theme-on-default: #fff;
  --theme-on-primary: #fff;
  --theme-on-secondary: rgb(50, 49, 48);
  --theme-on-error: #fff;
  --theme-on-success: #fff;

  --theme-on-background: #fff;

  --theme-on-surface: #fff;
}
html,
body {
  margin: 0;
  padding: 0;

  color: rgb(50, 49, 48);
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.application {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 1rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: max-content minmax(0, 1fr);
}

* {
  box-sizing: border-box;
}
</style>
